import { GraphContext } from 'contexts/Graph';
import { useContext } from 'react';

const useGraph = () => {
  return useContext(GraphContext);
};

export default useGraph;
